const order = {
  'orderList.title': 'Список заказов',
  'orderList.api.error.getOrderList': 'Ошибка получения списка заказов',
};

export default order;
